// extracted by mini-css-extract-plugin
module.exports = {"hidden":"srWarning_hidden__OVqOD","textEmphasis":"srWarning_textEmphasis__ZFsqz","warningWrap":"srWarning_warningWrap__xiQp0"};